type MinuteInterval = 15 | 20 | 30;
type HourInterval = 1 | 2 | 3 | 4 | 6 | 8 | 12;

enum PeriodicBoundry {
    minute = 60,
    hour = 24
}
function calculatePeriodicTimes(n: number, interval: number, boundry: PeriodicBoundry) {
    let val = n;
    const arr: number[] = [];
    do {
        arr.push(val);
        val = (val + interval) % boundry;
    } while (val !== n);
    return arr.sort((n1, n2) => n1 - n2).toString();
}

export function calculateMinutes(minutes: number, interval: MinuteInterval) {
    return calculatePeriodicTimes(minutes, interval, PeriodicBoundry.minute);
}

export function calculateHours(hour: number, interval: HourInterval) {
    return calculatePeriodicTimes(hour, interval, PeriodicBoundry.hour);
}
